module.exports = __webpack_public_path__ + "static/media/addTrialIcon.f6b43653.svg";